import Vue from 'vue'
import api from '@/api/api'
import {gameCatalog, setGameCatalog} from '@/common/mlbbBroadcast'

// хелперы читают справочники напрямую — делаем их реактивными, чтобы иконки появились после загрузки
Vue.observable(gameCatalog)

const KINDS = ['spells', 'items', 'emblems', 'talents']
let loading = null

/**
 * Справочники заклинаний, предметов, эмблем и талантов — один раз на вкладку.
 * Если ручка упала — остаются заглушки с ID, повторно не ходим (справочники меняются только с патчем).
 */
export function loadGameCatalog() {
    if (!loading) {
        loading = Promise.all(KINDS.map((kind) => api.mlbbEsports[kind]({skipErrorToast: true})
            .then((res) => setGameCatalog(kind, res?.data?.data))
            .catch(() => {})))
    }
    return loading
}
